module.exports = __webpack_public_path__ + "28cbec25e09bf0f8effc3ec53cbdb497.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TM.svg
// module id = 26sO
// module chunks = 0